import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import styles from './styles.module.scss';

function Navbar(props) {
  const {
    active,
    hasGlobalInsert,
    html,
    shortcuts,
    showGlobal,
    theme,
    showPolitics,
  } = props;

  return (
    <nav
      className={classNames(
        'hfsh init',
        {
          active,
          'has-global-insert': hasGlobalInsert,
          'show-global': showGlobal,
          'hide-global': !showGlobal,
          'show-shortcuts': shortcuts,
          politics: showPolitics,
          [theme]: theme,
        },
        [styles.override],
      )}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: html,
      }}
    />
  );
}

Navbar.propTypes = {
  active: PropTypes.bool.isRequired,
  hasGlobalInsert: PropTypes.bool.isRequired,
  html: PropTypes.string.isRequired,
  shortcuts: PropTypes.bool.isRequired,
  showGlobal: PropTypes.bool.isRequired,
  theme: PropTypes.string.isRequired,
  showPolitics: PropTypes.bool,
};

Navbar.defaultProps = {
  showPolitics: false,
};

const mapStateToProps = ({ navbar }) => ({
  active: navbar.active,
  hasGlobalInsert: navbar.hasGlobalInsert,
  shortcuts: navbar.shortcutsVisible,
  theme: navbar.theme,
});

export const HeaderNavbar = connect(mapStateToProps)(
  Navbar,
);
